// 경로별 title·description·og 값 — 브라우저(HeadTags)와 빌드 뒤 정적 HTML 생성(scripts/prerender.mjs)이 함께 쓴다
export const SITE_ORIGIN = 'https://jin-tonix.github.io';
export const SITE_NAME = 'Jinhee Mok · AI Engineer';
const OWNER = 'Jinhee Mok';
const DEFAULT_IMAGE = '/images/hero-bg.jpg';

// 옛 slug·옛 /projects/project6~9 → 새 case slug
export const LEGACY_SLUG_REDIRECT = {
  project6: 'agent-platform',
  project7: 'ss-worktool',
  project8: 'email-agent',
  project9: 'field-fleet',
  'sales-pipeline': 'ss-worktool',
  'company-os': 'agent-platform',
};

// 옛 한국어 기준 경로 → 새 경로 (SPA Navigate 와 정적 리다이렉트 스텁이 함께 쓴다)
export const LEGACY_ROUTE_REDIRECT = {
  '/build': '/how-i-build',
  // 옛 We:Review 페이지 — 사례에서 빠져 첫 화면으로 보낸다
  '/projects/project5': '/',
};

const clip = (text, max = 160) => {
  const flat = String(text || '').replace(/\s+/g, ' ').trim();
  return flat.length > max ? `${flat.slice(0, max - 1).trimEnd()}…` : flat;
};

const withOwner = (title) => `${title} · ${OWNER}`;

// /en 접두사를 뗀 경로, 끝 슬래시 없이
export function basePath(pathname) {
  const stripped = pathname.replace(/^\/en(?=\/|$)/, '') || '/';
  return stripped.length > 1 ? stripped.replace(/\/+$/, '') : '/';
}

// GitHub Pages 가 폴더 index.html 을 서빙하는 실제 주소 (끝 슬래시)
export function canonicalUrl(koPath, lang) {
  const prefix = lang === 'en' ? '/en' : '';
  const path = koPath === '/' ? '/' : `${koPath}/`;
  return `${SITE_ORIGIN}${prefix}${path}`;
}

// 사이트의 모든 한국어 기준 경로 (영문은 /en 을 붙인다)
export function allRoutes(content) {
  return [
    '/',
    '/about',
    '/skills',
    '/how-i-build',
    '/projects',
    ...content.cases.map((c) => `/projects/${c.slug}`),
  ];
}

export function routeMeta(content, koPath) {
  const heroHeading = `${content.hero.name} · ${content.hero.title}`;
  const base = { title: heroHeading, description: clip(content.hero.intro), image: DEFAULT_IMAGE, heading: heroHeading };
  if (koPath === '/') return base;

  const pages = {
    '/about': { title: content.about.title, description: content.about.tagline || content.about.paragraphs[0] },
    '/skills': { title: content.skills.title, description: content.skills.lead },
    '/how-i-build': { title: content.howIBuild.title, description: content.howIBuild.intro, image: content.howIBuild.image },
    '/projects': { title: content.nav.projects, description: content.systemMap.intro, image: content.systemMap.image },
  };
  if (pages[koPath]) {
    const p = pages[koPath];
    return { ...base, ...p, title: withOwner(p.title), description: clip(p.description), image: p.image || base.image, heading: p.title };
  }

  const m = koPath.match(/^\/projects\/([^/]+)$/);
  if (!m) return base;
  const slug = m[1];

  const c = content.cases.find((x) => x.slug === slug);
  if (c) {
    return {
      title: withOwner(c.shortTitle),
      description: clip(c.subtitle),
      image: (c.diagram && c.diagram.src) || base.image,
      heading: c.title,
      type: 'article',
    };
  }
  return base;
}
